import { FileUploadRequestBody } from "../common/common.model";
import client from "../auth/client";
import { Auth } from "../auth/auth";

export const postSignedUrlForDoc = async (reqBody: FileUploadRequestBody) => {
  const res = await client.post("/upload/", reqBody);
  return res.data;
};

export const getSignedUrlForDoc = async (reqBody: { file_name: string }) => {
  const res = await client.post("/get_signed_url/", reqBody);
  return res.data;
};

export const uploadDocFromLocal = async (reqBody: { file: File }) => {
  const res = await client.post("/upload_file_from_local/", reqBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const uploadFromLocalToDrive = async (reqBody: { file: File }) => {
  const res = await client.post("/doc_review/upload_from_local/", reqBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const convertDocToPdf = async (reqBody: { file_name: string }) => {
  const res = await client.post("/convert_doc_to_pdf_from_local/", reqBody);
  return res.data;
};

export const fileUploadFromDrive = async (reqBody: {
  file_name: string;
  file_id: string;
}) => {
  const res = await client.post("/doc_review/upload_drive_to_gcs/", {
    ...reqBody,
    token: Auth.getInstance().getGoogleAccessToken(),
  });
  return res.data;
};

export const getDocumentCommentFromServer = async (reqBody: {
  doc_id: string;
  mime_type?: string;
}) => {
  const res = await client.post(`/doc_review/review_document/`, reqBody);
  return res?.data;
};

export const getFileDataUsingDocId = async (docId: string) => {
  const res = await client.post("/doc_review/get_review_comments", {
    doc_id: docId,
  });

  return res?.data;
};

export const uploadMultipleFilesToDrive = async (docs: any) => {
  const res = await client.post("/doc_review/multi_upload_drive_to_gcs/", {
    token: Auth.getInstance().getGoogleAccessToken(),
    feature: "talk_to_contract",
    file_objects: docs,
  });
  return res.data;
};

export const uploadDraftingDocFromLocal = async (reqBody: {
  intake_form: File,
  id_template_mapping: string
}) => {
  const res = await client.post("/draft_contract/upload_intake_form/", reqBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const draftingFileUploadFromDrive = async (reqBody: {
  file_name: string;
  file_id: string;
}) => {
  const res = await client.post("/doc_review/upload_drive_to_gcs/", {
    ...reqBody,
    token: Auth.getInstance().getGoogleAccessToken(),
  });
  return res.data;
};

export const getSampleDownloadIntakeForm = async (templateId: string) => {
  const res = await client.post("/draft_contract/download_intake_form/", {
    id_template_mapping: templateId,
  });

  return res?.data;
};

export const uploadRfxGeneratorDocFromLocal = async (reqBody: {
  intake_form: File,
  rfx_template_id: string
}) => {
  const res = await client.post("/generate_rfx/upload_intake_form_from_local/", reqBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const getSampleRfxGeneratorDownloadIntakeForm = async (intakeFormGcsLoc: string) => {
  const res = await client.post("/generate_rfx/download_intake_form/", {
    rfx_intake_form_gcs_loc: intakeFormGcsLoc,
  });

  return res?.data;
};

export const uploadFilesFromLocalForClauseCheck = async (reqBody: FormData) => {
  const auth = Auth.getInstance();
  reqBody.append("token", auth.getGoogleAccessToken() || "");
  reqBody.append("feature", "clause_check");

  const res = await client.post("/clause_check/multi_upload_local_to_gcs/", reqBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};

export const uploadMultipleFilesFromLocalForTalkToContract = async (reqBody: FormData) => {
  const res = await client.post("/doc_review/local_upload/", reqBody, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
};
